import Form from "./Form";

export default Form;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/Form/index.js